import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'employeeResourcePlanner';

const employeeResourcePlannerService = {
  getEmployeeByType: (type) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/employee/${encodeURIComponent(type)}`,
    });
  },

  getTasks: (data, type) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/tasks/${encodeURIComponent(type)}`,
      data,
    });
  },

  updateEmployeeAbsence: (data, id) => {
    return request({
      method: Methods.PATCH,
      resource: `${baseURL}/employeeAbsence/${encodeURIComponent(id)}`,
      data,
    });
  },
};
export default employeeResourcePlannerService;
